var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "integrations" } },
    [
      _c(
        "AppBreadCrumb",
        { attrs: { paths: [{ title: _vm.$t("wp.whatsapp") }], select: true } },
        [
          _vm.initialized && _vm.status.purchased
            ? _c(
                "a-button",
                {
                  staticClass: "actionButtonBreadcrumb",
                  attrs: { type: "danger" },
                  on: { click: _vm.unsubscribe },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("wp.unsubscribe")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.status.purchased
            ? _c(
                "a-button",
                {
                  staticClass: "actionButtonBreadcrumb ml-1",
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.debugModalVisible = true
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("whatsapp.wpDebugTool")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            { staticClass: "side-menubar-wrapper" },
            [_c("WhatsappMenu", { attrs: { "selected-page": "integration" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _c(
                "a-spin",
                { attrs: { tip: "Loading...", spinning: !_vm.initialized } },
                [
                  _c(
                    "div",
                    { staticClass: "spin-content" },
                    [
                      _vm.showWizard
                        ? _c("WhatsappWizard")
                        : _c(
                            "b-card",
                            [
                              _c(
                                "b-card-body",
                                {
                                  staticClass:
                                    "h-100 d-flex flex-column justify-content-center align-items-center my-0",
                                  staticStyle: { "min-height": "22vh" },
                                },
                                [
                                  _c(
                                    "md-icon",
                                    {
                                      staticClass:
                                        "wp-icon-wp-integration mb-2 mr-1 ml-1",
                                      staticStyle: {
                                        color: "#06e576 !important",
                                        "font-size": "60px !important",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                whatsapp\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "h4",
                                    { staticStyle: { "margin-top": "5px" } },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "1px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "wp.toEnableWpDescription"
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        icon: "unlock",
                                        size: "large",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.showWizard = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.$t("wp.enableFeature")) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-card-body",
                                {
                                  staticClass:
                                    "h-100 d-flex flex-column justify-content-center align-items-center my-2",
                                  staticStyle: { "min-height": "22vh" },
                                },
                                [
                                  [
                                    _c(
                                      "a-carousel",
                                      {
                                        staticStyle: {
                                          height: "500px !important",
                                          width: "960px !important",
                                        },
                                        attrs: {
                                          arrows: "",
                                          "dots-class":
                                            "slick-dots slick-thumb",
                                          autoplay: true,
                                          dotPosition: "bottom",
                                        },
                                      },
                                      _vm._l(3, function (item) {
                                        return _c("div", [
                                          _c("img", {
                                            attrs: {
                                              src: _vm.baseUrl[item - 1],
                                            },
                                          }),
                                        ])
                                      }),
                                      0
                                    ),
                                  ],
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "debug-tool",
          attrs: { title: "Whatsapp Service Debug Tool", centered: "" },
          model: {
            value: _vm.debugModalVisible,
            callback: function ($$v) {
              _vm.debugModalVisible = $$v
            },
            expression: "debugModalVisible",
          },
        },
        [_c("WhatsappDebugTool")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }